<div class="modal-box add-campaign-check-modal" cdkDrag>
    <form class="add-campaign-check-modal__form modal-form" [formGroup]="addCampaignCheckForm" (ngSubmit)="onSubmit()">
        <div class="modal-header modal-bar add-campaign-check-modal__header" cdkDragHandle>
            <div class="add-campaign-check-modal__headline modal-headline">
                <span class="add-campaign-check-modal__eyebrow modal-eyebrow">{{ 'CAMPAIGN_CHECK' | translate }}</span>
                <h4 class="modal-title add-campaign-check-modal__title modal-heading">
                    <a href="/pages/campaign-details/{{iCampaignId}}" target="_blank">{{campaignData.name}}</a>
                    <span class="add-campaign-check-modal__meta"> (<a href="/pages/client-details/{{iClientId}}" target="_blank">{{campaignData.clientName}}</a>) - <span class="add-campaign-check-modal__platform">{{campaignData.platform}}</span> ({{ campaignData.stageId | P_CampaignStageTitle }})</span>
                </h4>
            </div>
            <button type="button" class="add-campaign-check-modal__close modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body add-campaign-check-modal__body">
            <div class="row">
                <div class="col-sm-4 add-campaign-check-modal__sidebar" fxLayout="column" fxLayoutAlign="space-between stretch">
                    <div class="campaignInfo add-campaign-check-modal__panel add-campaign-check-modal__panel--campaign-info" fxLayout="column" fxLayoutAlign="space-between stretch">
                        <div *ngIf="(mostRecentOrder !== {})" [class.red]="(activeSubscription?.status || '').toLowerCase() !== 'active' || mostRecentOrder?.paid === false" fxLayout="column" fxLayoutGap="0px" class="orderInfo">
                            <div fxLayout="row" fxLayoutAlign="center stretch">
                                <h5>{{ 'SUBSCRIPTION_STATUS' | translate }}:
                                <span style="padding-left: 3.5px;">
                                    <ng-container *ngIf="activeSubscription?.status !== 'NO_ACTIVE_SUBSCRIPTION'; else noSubscriptionLink">
                                        <a href="/pages/subscriptions/{{activeSubscription?.id}}" target="_blank">{{ activeSubscription?.status | P_SubscriptionStatus }}</a>
                                    </ng-container>
                                    <ng-template #noSubscriptionLink>
                                        {{ activeSubscription.status | translate }}
                                    </ng-template>
                                </span></h5>
                            </div>
                            <div fxLayout="row" fxLayoutGap="1em" class="mt-2">
                                <div fxLayout="row" fxFlex>
                                    <strong>{{ 'MOST_RECENT_ORDER_STATUS' | translate }}: </strong>
                                    <span style="padding-left: 3.5px;"><a href="/pages/orders/details/{{mostRecentOrder.id}}" target="_blank">{{ getOrderStatusKey(mostRecentOrder) | translate }}<ng-container *ngIf="getOrderRefundStatusKey(mostRecentOrder) as refundStatusKey"> {{ refundStatusKey | translate }}</ng-container></a></span>
                                </div>
                                <div fxLayout="row" fxFlex>
                                    <strong>{{ 'ORDER_DATE' | translate }}: </strong>
                                    <span style="padding-left: 3.5px;">{{ mostRecentOrder.generatedOn | date:'mediumDate' }}</span>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutGap="1em">
                                <div fxLayout="row" fxFlex>
                                    <strong>{{ 'AD_SPEND_PAID' | translate }}: </strong>
                                    <span *ngIf="thisMonthsAdspend > 0" style="padding-left: 3.5px;">{{ thisMonthsAdspend | currency:'USD':'symbol':'1.2-2' }}</span>
                                </div>
                                <div fxLayout="row" fxFlex>
                                    <strong>{{ 'MTD_SPEND' | translate }}: </strong>
                                    <span *ngIf="externalMonthToDateCost !== null" style="padding-left: 3.5px;">{{ externalComparisonsLoading ? ('LOADING_DOTS' | translate) : (externalMonthToDateCost | currency:'USD':'symbol':'1.2-2') }}</span>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutGap="1em">
                                <div fxLayout="row" fxFlex>
                                    <strong>{{ 'AD_SPEND_REMAINING' | translate }}: </strong>
                                    <span *ngIf="externalMonthToDateCost !== null" style="padding-left: 3.5px;">{{ externalComparisonsLoading ? ('LOADING_DOTS' | translate) : ((thisMonthsAdspend - externalMonthToDateCost) | currency:'USD':'symbol':'1.2-2') }}</span>
                                </div>
                                <div fxLayout="row" fxFlex>
                                    <strong>{{ 'DAILY_SPEND_SHOULD_BE' | translate }}: </strong>
                                    <span *ngIf="externalMonthToDateCost !== null && daysLeftInMonthIncludingToday > 0" style="padding-left: 3.5px;">{{ externalComparisonsLoading ? ('LOADING_DOTS' | translate) : (dailySpendShouldBe | currency:'USD':'symbol':'1.2-2') }}</span>
                                </div>
                            </div>
                            <div fxLayout="row" fxLayoutGap="1em">
                                <div fxLayout="row" fxFlex [ngClass]="projectedMonthlySpendDirection">
                                    <strong>{{ 'PROJECTED_MONTHLY_SPEND' | translate }}: </strong>
                                    <span *ngIf="externalMonthToDateCost !== null" style="padding-left: 3.5px;">{{ externalComparisonsLoading ? ('LOADING_DOTS' | translate) : (projectedMonthlySpend | currency:'USD':'symbol':'1.2-2') }}</span>

                                    <span *ngIf="externalMonthToDateCost !== null" style="padding-left: 3.5px;"> ({{ externalComparisonsLoading ? ('LOADING_DOTS' | translate) : ((projectedMonthlySpendDelta | currency:'USD':'symbol':'1.2-2') + ' ' + (projectedMonthlySpendDisplayDirectionKey | translate)) }})</span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="campaignData.opportunityNotes > ''" class="mt-3 campaign-additional-info">
                            <strong>{{ 'CAMPAIGN_ADDITIONAL_INFO' | translate }}:</strong>
                            <p>{{ campaignData.opportunityNotes }}</p>
                        </div>

                        <div class="notes-tabs mt-3">
                            <button type="button"
                                class="notes-tab"
                                [class.active]="activeNotesSection === 'campaign'"
                                (click)="setActiveNotesSection('campaign')">
                                {{ 'CAMPAIGN_NOTES' | translate }}
                            </button>
                            <button type="button"
                                class="notes-tab"
                                [class.active]="activeNotesSection === 'client'"
                                (click)="setActiveNotesSection('client')">
                                {{ 'CLIENT_NOTES' | translate }}
                            </button>
                            <button type="button"
                                class="notes-tab"
                                [class.active]="activeNotesSection === 'tasks'"
                                (click)="setActiveNotesSection('tasks')">
                                {{ 'UPCOMING_TASKS' | translate }}
                            </button>
                        </div>

                        <div fxFlex>
                            <div class="notes-panel" *ngIf="activeNotesSection === 'campaign'">
                                <ul class="notes-list" *ngIf="campaignNotes.length > 0; else noCampaignNotes">
                                    <li *ngFor="let note of campaignNotes">
                                        <strong>{{ note.title }}</strong>
                                        <br />
                                        <small>{{ note.updatedOn | date:'mediumDate' }}</small>
                                        <small> - {{ note.assignedUserName }}</small>
                                        <p>{{ note.description }}</p>
                                    </li>
                                </ul>
                                <ng-template #noCampaignNotes><p class="notes-empty">{{ 'NO_CAMPAIGN_NOTES_AVAILABLE' | translate }}</p></ng-template>
                            </div>

                            <div class="notes-panel" *ngIf="activeNotesSection === 'client'">
                                <ul class="notes-list" *ngIf="clientNotes.length > 0; else noClientNotes">
                                    <li *ngFor="let note of clientNotes">
                                        <strong>{{ note.title }}</strong>
                                        <br />
                                        <small>{{ note.updatedOn | date:'mediumDate' }}</small>
                                        <small> - {{ note.assignedUserName }}</small>
                                        <p>{{ note.description }}</p>
                                    </li>
                                </ul>
                                <ng-template #noClientNotes><p class="notes-empty">{{ 'NO_CLIENT_NOTES_AVAILABLE' | translate }}</p></ng-template>
                            </div>

                            <div class="notes-panel" *ngIf="activeNotesSection === 'tasks'">
                                <ul class="notes-list" *ngIf="tasksDataNotCompleted.length > 0; else noTasks">
                                    <li *ngFor="let task of tasksDataNotCompleted">
                                        <strong>{{ task.title }} - {{ task.assignedUserName }}</strong>
                                        <br />
                                        <small>Due: {{ task.dueDate | date:'mediumDate' }}</small>
                                        <p>{{ task.description }}</p>
                                    </li>
                                </ul>
                                <ng-template #noTasks><p class="notes-empty">{{ 'NO_UPCOMING_TASKS_AVAILABLE' | translate }}</p></ng-template>
                            </div>
                        </div>
                    </div>
                    <div class="updateTask add-campaign-check-modal__panel add-campaign-check-modal__panel--update mt-3">
                        <ng-container *ngIf="iTask?.id; else noTaskContext">
                            <div class="row mb-1">
                                <h5>{{ 'UPDATE_EXISTING_CHECK' | translate }}:</h5>
                            </div>
                            <div class="row">
                                <div class="col-sm-6">
                                    <label class="modal-label" for="dueDate">{{ 'DUE_DATE' | translate }}</label>
                                    <input mwlFlatpickr
                                        [altInputClass]="'datetime'" [altInput]="true" [convertModelValue]="true" formControlName="dueDate"
                                        class="form-control modal-control" />
                                </div>
                                <div class="col-sm-6">
                                    <label class="modal-label" for="assignedUserId">{{ 'ASSIGNED_USER' | translate }}</label>
                                    <ng-select class="modal-select" [placeholder]="'NONE' | translate" [items]="allUsers" bindLabel="fullName" bindValue="id" formControlName="assignedUserId">
                                    </ng-select>
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-auto">
                                    <button
                                        type="button"
                                        class="gray-button"
                                        [disabled]="taskUpdateSaving"
                                        (click)="updateTriggerTask()">
                                        {{ taskUpdateSaving ? ('UPDATING_DOTS' | translate) : ('UPDATE_TASK' | translate) }}
                                    </button>
                                    <small *ngIf="taskUpdateError" class="text-danger ms-2">{{ taskUpdateError }}</small>
                                </div>
                            </div>
                        </ng-container>
                        <ng-template #noTaskContext>
                            <div class="row mb-3">
                                <div class="col-12">
                                    <small class="text-muted">{{ 'TASK_CONTEXT_NOT_AVAILABLE' | translate }}</small>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
                <div class="col-sm-8 add-campaign-check-modal__main">
                    <div class="tier-banner tier-banner--compact add-campaign-check-modal__tier-banner" *ngIf="isTiered" [ngClass]="tierBannerClass" role="status">
                        <h5 class="tier-banner__title">{{ tierName | P_TierName }}</h5>
                    </div>
                    <div class="notes-tabs mb-2">
                        <button type="button"
                            class="notes-tab"
                            [class.active]="activeExternalSection === 'metrics'"
                            (click)="setActiveExternalSection('metrics')">
                            {{ 'METRICS' | translate }}
                        </button>
                        <button type="button"
                            class="notes-tab"
                            [class.active]="activeExternalSection === 'campaignAudit'"
                            [class.campaign-audit-attention]="highlightCampaignAuditTab"
                            (click)="setActiveExternalSection('campaignAudit')">
                            {{ 'CAMPAIGN_AUDIT' | translate }}
                        </button>
                        <button type="button"
                            class="notes-tab"
                            [class.active]="activeExternalSection === 'budgetAudit'"
                            (click)="setActiveExternalSection('budgetAudit')">
                            {{ 'BUDGET_AUDIT' | translate }}
                        </button>
                        <button type="button"
                            class="notes-tab"
                            [class.active]="activeExternalSection === 'redAlertDeepDive'"
                            (click)="setActiveExternalSection('redAlertDeepDive')">
                            {{ 'RED_ALERT_DEEP_DIVE' | translate }}
                        </button>
                        <button type="button"
                            class="notes-tab"
                            [class.active]="activeExternalSection === 'tars'"
                            (click)="setActiveExternalSection('tars')">
                            TARS
                        </button>
                    </div>

                    <div *ngIf="activeExternalSection === 'metrics'" class="add-campaign-check-modal__metrics-section">
                        <div class="checkMetrics" *ngIf="externalCampaignRows.length > 1" class="mb-3">
                            <div class="row">
                                <div class="col-12">
                                    <div class="add-campaign-check-modal__metrics-table-shell">
                                        <table class="table table-sm table-striped mb-0 add-campaign-check-modal__metrics-table" style="font-size: 12px;">
                                            <thead>
                                                <tr>
                                                    <th>{{ 'CAMPAIGNS_LAST_7_DAYS' | translate }}</th>
                                                    <th class="text-end">{{ 'IMPR' | translate }}</th>
                                                    <th class="text-end">{{ 'CLICKS' | translate }}</th>
                                                    <th class="text-end">{{ metricCountLabel | translate }}</th>
                                                    <th class="text-end">{{ 'CTR' | translate }}</th>
                                                    <th class="text-end">{{ (isGooglePlatform ? 'CPC' : 'CPM') | translate }}</th>
                                                    <th class="text-end">{{ metricRateLabel | translate }}</th>
                                                    <th class="text-end">{{ metricCostLabel | translate }}</th>
                                                    <th class="text-end">{{ 'COST' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let row of externalCampaignRows">
                                                    <td style="max-width: 340px;" title="{{ row.campaignName }}">{{ row.campaignName }}</td>
                                                    <td class="text-end">{{ row.impressions | number:'1.0-0' }}</td>
                                                    <td class="text-end">{{ row.clicks | number:'1.0-0' }}</td>
                                                    <td class="text-end">{{ getDisplayMetricCount(row) | number:'1.0-0' }}</td>
                                                    <td class="text-end">{{ row.ctrPct === null ? '-' : (row.ctrPct | number:'1.0-2') + '%' }}</td>
                                                    <td class="text-end">{{ row.cpmOrCpc === null ? '-' : (row.cpmOrCpc | currency:'USD':'symbol':'1.2-2') }}</td>
                                                    <td class="text-end">{{ getDisplayMetricRate(row) === null ? '-' : (getDisplayMetricRate(row) | number:'1.0-2') + '%' }}</td>
                                                    <td class="text-end">{{ getDisplayMetricCost(row) === null ? '-' : (getDisplayMetricCost(row) | currency:'USD':'symbol':'1.2-2') }}</td>
                                                    <td class="text-end">{{ row.cost | currency:'USD':'symbol':'1.2-2' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="row" *ngIf="externalDailyLoading || externalComparisonsLoading">
                                <div class="col-12">
                                    <small class="text-muted">{{ 'LOADING_EXTERNAL_METRICS' | translate }}</small>
                                </div>
                            </div>

                            <div class="row" *ngIf="(!externalDailyLoading && externalDailyRows.length === 0) && (!externalComparisonsLoading && externalRangeComparisons.length === 0)">
                                <div class="col-12">
                                    <span class="text-muted">{{ 'NO_EXTERNAL_METRICS_DATA_AVAILABLE' | translate }}</span>
                                </div>
                            </div>

                            <div class="row" *ngIf="externalDailyRows.length > 0 || externalRangeComparisons.length > 0">
                                <div class="col-md-6 add-campaign-check-modal__metrics-column">
                                    <div class="add-campaign-check-modal__metrics-table-shell">
                                        <table class="table table-sm table-striped mb-0 add-campaign-check-modal__metrics-table" style="font-size: 12px;">
                                            <thead>
                                                <tr>
                                                    <th>{{ 'DAY' | translate }}</th>
                                                    <th class="text-end">{{ 'IMPR' | translate }}</th>
                                                    <th class="text-end">{{ 'CLICKS' | translate }}</th>
                                                    <th class="text-end">{{ metricCountLabel | translate }}</th>
                                                    <th class="text-end">{{ 'REACH_LEADS' | translate }}</th>
                                                    <th class="text-end">{{ 'SPEND' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let row of externalDailyRows">
                                                    <td>{{ row.date }}</td>
                                                    <td class="text-end">{{ row.impressions | number:'1.0-0' }}</td>
                                                    <td class="text-end">{{ row.clicks | number:'1.0-0' }}</td>
                                                    <td class="text-end">{{ getDisplayMetricCount(row) | number:'1.0-0' }}</td>
                                                    <td class="text-end">{{ row.reachLeads | number:'1.0-0' }}</td>
                                                    <td class="text-end">{{ row.cost | currency:'USD':'symbol':'1.2-2' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div class="col-md-6 add-campaign-check-modal__metrics-column" *ngIf="externalRangeComparisons.length > 0">
                                    <div class="add-campaign-check-modal__metrics-table-shell">
                                        <table class="table table-sm table-striped mb-0 add-campaign-check-modal__comparison-table add-campaign-check-modal__metrics-table" style="font-size: 12px;">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th *ngFor="let r of externalRangeComparisons" class="text-end add-campaign-check-modal__comparison-header">
                                                        <div class="add-campaign-check-modal__comparison-label">{{ r.label | translate }}</div>
                                                        <div class="text-muted add-campaign-check-modal__comparison-dates">{{ r.startDate }} - <br>{{ r.endDate }}</div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>{{ metricCountLabel | translate }}</th>
                                                    <td *ngFor="let r of externalRangeComparisons" class="text-end">{{ getDisplayMetricCount(r) | number:'1.0-0' }}</td>
                                                </tr>
                                                <tr>
                                                    <th>{{ metricCostLabel | translate }}</th>
                                                    <td *ngFor="let r of externalRangeComparisons" class="text-end">{{ getDisplayMetricCost(r) === null ? '-' : (getDisplayMetricCost(r) | currency:'USD':'symbol':'1.2-2') }}</td>
                                                </tr>
                                                <tr>
                                                    <th>{{ 'CTR' | translate }}</th>
                                                    <td *ngFor="let r of externalRangeComparisons" class="text-end">{{ r.ctrPct === null ? '-' : (r.ctrPct | number:'1.0-2') + '%' }}</td>
                                                </tr>
                                                <tr>
                                                    <th>{{ (isGooglePlatform ? 'CPC' : 'CPM') | translate }}</th>
                                                    <td *ngFor="let r of externalRangeComparisons" class="text-end">
                                                        {{
                                                            (isGooglePlatform
                                                                ? (r.clicks > 0 ? (r.cost / r.clicks) : null)
                                                                : r.cpm
                                                            ) === null
                                                                ? '-'
                                                                : ((isGooglePlatform
                                                                    ? (r.clicks > 0 ? (r.cost / r.clicks) : null)
                                                                    : r.cpm) | currency:'USD':'symbol':'1.2-2')
                                                        }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{{ metricRateLabel | translate }}</th>
                                                    <td *ngFor="let r of externalRangeComparisons" class="text-end">{{ getDisplayMetricRate(r) === null ? '-' : (getDisplayMetricRate(r) | number:'1.0-2') + '%' }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="activeExternalSection === 'campaignAudit'">
                        <div class="row">
                            <div class="col-12">
                                <h5 class="mt-2">{{ 'CAMPAIGN_AUDIT' | translate }}</h5>
                                <span class="text-muted d-block mb-2" *ngIf="mostRecentCampaignAuditNoteDate as lastAuditDate; else noAuditFound">
                                    {{ 'LAST_CAMPAIGN_AUDIT' | translate }}: {{ lastAuditDate | date:'mediumDate' }}
                                </span>
                                <ng-template #noAuditFound>
                                    <span class="text-muted d-block mb-2">{{ 'LAST_CAMPAIGN_AUDIT_NOT_FOUND' | translate }}</span>
                                </ng-template>
                                <div class="campaignAuditChecklist">
                                    <div class="form-check" *ngFor="let item of campaignAuditChecklist">
                                        <input class="form-check-input"
                                            type="checkbox"
                                            [id]="item.key"
                                            [formControlName]="item.key" />
                                        <label class="form-check-label" [for]="item.key">{{ item.label | translate }}</label>
                                    </div>
                                </div>
                                <textarea
                                    rows="3"
                                    class="form-control mt-2 half-width"
                                    formControlName="auditAdditionalInfo"
                                    [placeholder]="'ADDITIONAL_INFORMATION' | translate">
                                </textarea>
                            </div>
                        </div>
                    </div>

                    <div [hidden]="activeExternalSection !== 'budgetAudit'">
                        <app-campaign-budget-audit
                            *ngIf="budgetAuditInitialized"
                            [iCampaignId]="iCampaignId"
                            [iLayout]="'row'">
                        </app-campaign-budget-audit>
                    </div>

                    <div *ngIf="activeExternalSection === 'redAlertDeepDive'">
                        <div class="row">
                            <h5 class="mt-2">{{ 'RED_ALERT_DEEP_DIVE' | translate }}</h5>
                            <span class="text-muted d-block mb-2" *ngIf="mostRecentRedAlertDeepDiveNoteDate as lastRadDate; else noRadFound">
                                {{ 'LAST_RED_ALERT_DEEP_DIVE' | translate }}: {{ lastRadDate | date:'mediumDate' }}
                            </span>
                            <ng-template #noRadFound>
                                <span class="text-muted d-block mb-2">{{ 'LAST_RED_ALERT_DEEP_DIVE_NOT_FOUND' | translate }}</span>
                            </ng-template>

                            <div class="col-7 mt-3">
                                <h6>{{ 'INVESTIGATION' | translate }}</h6>
                                <p class="text-muted mb-2">
                                    {{ 'RED_ALERT_DEEP_DIVE_DESCRIPTION' | translate }}
                                </p>

                                <div class="campaignAuditChecklist">
                                    <div class="form-check" *ngFor="let item of redAlertDeepDiveChecklist">
                                        <input class="form-check-input"
                                            type="checkbox"
                                            [id]="item.key"
                                            [formControlName]="item.key" />
                                        <label class="form-check-label" [for]="item.key">{{ item.label | translate }}</label>
                                    </div>
                                </div>

                                <textarea
                                    rows="3"
                                    class="form-control mt-2"
                                    formControlName="radDdAdditionalInfo"
                                    [placeholder]="'ADDITIONAL_INFORMATION_REGARDING_FINDINGS' | translate">
                                </textarea>
                            </div>

                            <div class="col-5 mt-3">
                                <h6>{{ 'ACTIONS_TAKEN' | translate }}</h6>
                                <p class="text-muted mb-2">
                                    {{ 'RED_ALERT_ACTIONS_TAKEN_DESCRIPTION' | translate }}
                                </p>

                                <div class="campaignAuditChecklist">
                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="radActFixedConversionTracking" formControlName="radActFixedConversionTracking" />
                                        <label class="form-check-label" for="radActFixedConversionTracking">{{ 'FIXED_CONVERSION_TRACKING' | translate }}</label>
                                    </div>

                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="radActRevertedPreviousChanges" formControlName="radActRevertedPreviousChanges" />
                                        <label class="form-check-label" for="radActRevertedPreviousChanges">{{ 'REVERTED_PREVIOUS_CHANGES' | translate }}:</label>
                                    </div>

                                    <div *ngIf="f.radActRevertedPreviousChanges?.value" style="margin-left: 1.5rem;" class="mb-2">
                                        <div class="form-check" *ngFor="let item of redAlertRevertedPreviousChangesChecklist">
                                            <input class="form-check-input"
                                                type="checkbox"
                                                [id]="item.key"
                                                [formControlName]="item.key" />
                                        <label class="form-check-label" [for]="item.key">{{ item.label | translate }}</label>
                                        </div>

                                        <div *ngIf="f.radActRevertedOther?.value" class="mt-1">
                                            <input type="text" class="form-control form-control-sm" formControlName="radActRevertedOtherText" [placeholder]="'OTHER' | translate" />
                                        </div>
                                    </div>

                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="radActKpiProblemFoundAndCorrected" formControlName="radActKpiProblemFoundAndCorrected" />
                                        <label class="form-check-label" for="radActKpiProblemFoundAndCorrected">{{ 'KPI_PROBLEM_FOUND_AND_CORRECTED' | translate }}:</label>
                                    </div>

                                    <div *ngIf="f.radActKpiProblemFoundAndCorrected?.value" style="margin-left: 1.5rem;" class="mb-2">
                                        <div class="form-check" *ngFor="let item of redAlertKpiProblemChecklist">
                                            <input class="form-check-input"
                                                type="checkbox"
                                                [id]="item.key"
                                                [formControlName]="item.key" />
                                        <label class="form-check-label" [for]="item.key">{{ item.label | translate }}</label>
                                        </div>

                                        <div *ngIf="f.radActKpiOther?.value" class="mt-1">
                                            <input type="text" class="form-control form-control-sm" formControlName="radActKpiOtherText" [placeholder]="'OTHER' | translate" />
                                        </div>
                                    </div>

                                    <div class="form-check">
                                        <input class="form-check-input" type="checkbox" id="radActSentToStrategyForReview" formControlName="radActSentToStrategyForReview" />
                                        <label class="form-check-label" for="radActSentToStrategyForReview">{{ 'SENT_TO_STRATEGY_FOR_REVIEW' | translate }}</label>
                                    </div>
                                </div>

                                <textarea
                                    rows="3"
                                    class="form-control mt-2"
                                    formControlName="radActAdditionalInfo"
                                    [placeholder]="'ADDITIONAL_INFORMATION_ABOUT_ACTIONS_TAKEN' | translate">
                                </textarea>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="activeExternalSection === 'tars'" class="add-campaign-check-modal__tars">
                        <div class="row mb-2" *ngIf="tarsLoading">
                            <div class="col-12"><small class="text-muted">Loading TARS campaign review...</small></div>
                        </div>

                        <div class="alert alert-danger" role="alert" *ngIf="tarsError">
                            {{ tarsError }}
                            <button type="button" class="btn btn-sm btn-outline-danger ms-2" (click)="loadTarsReview(true)">Retry</button>
                        </div>

                        <div class="notes-tabs mb-2" *ngIf="tarsResults.length > 1">
                            <button type="button"
                                class="notes-tab"
                                *ngFor="let result of tarsResults; let index = index"
                                [class.active]="activeTarsResultIndex === index"
                                (click)="setActiveTarsResult(index)">
                                {{ result.campaignName || result.campaignId }}
                            </button>
                        </div>

                        <ng-container *ngIf="tarsResults[activeTarsResultIndex] as selectedTarsResult">
                            <div class="alert alert-danger" role="alert" *ngIf="selectedTarsResult.error">
                                {{ selectedTarsResult.error }}
                            </div>
                            <ng-container *ngIf="selectedTarsResult.response as tarsResponse">
                                <details class="tars-response-section" open>
                                    <summary>SUMMARY</summary>
                                    <div class="tars-summary-content" *ngIf="getTarsSectionData(tarsResponse, 'summary') as tarsSummary">
                                        <div class="tars-summary-facts">
                                            <div class="tars-summary-fact">
                                                <strong>Campaign Health</strong>
                                                <span>{{ tarsSummary.campaign_health | titlecase }}</span>
                                            </div>
                                            <div class="tars-summary-fact">
                                                <strong>Current Action</strong>
                                                <span>{{ tarsSummary.current_action | titlecase }}</span>
                                            </div>
                                            <div class="tars-summary-fact">
                                                <strong>KPI Focus</strong>
                                                <span>{{ formatTarsKpiFocus(tarsSummary.kpi_focus) }}</span>
                                            </div>
                                            <div class="tars-summary-fact">
                                                <strong>Trend</strong>
                                                <span>{{ tarsSummary.grades?.overall_grade?.trend_category | titlecase }}</span>
                                            </div>
                                            <div class="tars-summary-fact">
                                                <strong>Short-Term Grade: {{ tarsSummary.grades?.short_term_grade?.grade || '—' }}</strong>
                                                <span>{{ tarsSummary.grades?.short_term_grade?.score | number:'1.0-2' }}/100</span>
                                            </div>
                                            <div class="tars-summary-fact">
                                                <strong>Long-Term Grade: {{ tarsSummary.grades?.long_term_grade?.grade || '—' }}</strong>
                                                <span>{{ tarsSummary.grades?.long_term_grade?.score | number:'1.0-2' }}/100</span>
                                            </div>
                                            <div class="tars-summary-fact">
                                                <strong>Overall Grade: {{ tarsSummary.grades?.overall_grade?.grade || '—' }}</strong>
                                                <span>{{ tarsSummary.grades?.overall_grade?.score | number:'1.0-2' }}/100</span>
                                            </div>
                                        </div>

                                        <section class="tars-summary-block">
                                            <h6>Overview</h6>
                                            <p>{{ tarsSummary.overview || tarsSummary.headline }}</p>
                                        </section>

                                        <section class="tars-summary-block">
                                            <h6>What To Do</h6>
                                            <ul *ngIf="tarsSummary.what_to_do?.items?.length; else tarsWhatToDoText">
                                                <li *ngFor="let item of tarsSummary.what_to_do.items">{{ item }}</li>
                                            </ul>
                                            <ng-template #tarsWhatToDoText>
                                                <p>{{ tarsSummary.what_to_do?.text }}</p>
                                            </ng-template>
                                        </section>

                                        <section class="tars-summary-block">
                                            <div class="tars-summary-heading">
                                                <h6>Insights</h6>
                                                <button
                                                    type="button"
                                                    class="btn btn-sm btn-outline-secondary"
                                                    *ngIf="tarsSummary.insights?.length"
                                                    (click)="copyTarsInsightsToCheck(tarsSummary.insights)">
                                                    Copy to Check
                                                </button>
                                            </div>
                                            <ul>
                                                <li *ngFor="let insight of tarsSummary.insights">{{ insight }}</li>
                                            </ul>
                                        </section>
                                    </div>
                                </details>
                                <details class="tars-response-section">
                                    <summary>RECOMMENDATIONS</summary>
                                    <div class="tars-recommendations-content">
                                <ng-container *ngIf="getTarsSectionData(tarsResponse, 'recommendations') as tarsRecommendationData; else tarsRecommendationsUnavailable">
                                <ng-container *ngIf="tarsRecommendationData.peer_benchmarks as tarsAllOfferBenchmarks; else tarsRecommendationsUnavailable">
                                    <div class="tars-recommendations-meta">
                                        <div>
                                            <strong>Status:</strong> {{ getTarsRecommendationMetadata(tarsAllOfferBenchmarks).available ? 'Available' : 'Unavailable' }}
                                            <span class="tars-recommendations-meta__separator">|</span>
                                            <strong>Brand:</strong> {{ getTarsRecommendationMetadata(tarsAllOfferBenchmarks).brand || '—' }}
                                            <span class="tars-recommendations-meta__separator">|</span>
                                            <strong>Window:</strong> {{ formatTarsRecommendationWindow(getTarsRecommendationMetadata(tarsAllOfferBenchmarks).window) }}
                                        </div>
                                    </div>

                                    <ng-container *ngIf="tarsAllOfferBenchmarks.offer_dependent_context as tarsSpecificOffer">
                                        <details class="tars-recommendation-scope" [open]="hasTarsOfferSpecificContent(tarsSpecificOffer)">
                                            <summary>{{ getTarsSpecificOfferTitle(tarsSpecificOffer) }}</summary>
                                            <div class="tars-recommendations-panel">
                                                <p>These recommendations are limited to same-brand campaigns using this offer.</p>
                                                <ng-container *ngIf="hasTarsOfferSpecificContent(tarsSpecificOffer); else tarsSpecificOfferEmpty">
                                                    <ng-container *ngTemplateOutlet="tarsRecommendationTable; context: { $implicit: tarsSpecificOffer.lead_form_candidates, title: 'Lead-form', metricKey: 'lsr', metricLabel: 'LSR' }"></ng-container>
                                                    <ng-container *ngTemplateOutlet="tarsRecommendationTable; context: { $implicit: tarsSpecificOffer.copy_candidates, title: 'Copy', metricKey: 'ctr', metricLabel: 'CTR' }"></ng-container>
                                                    <ng-container *ngTemplateOutlet="tarsRecommendationTable; context: { $implicit: tarsSpecificOffer.creative_candidates, title: 'Creative', metricKey: 'ctr', metricLabel: 'CTR' }"></ng-container>
                                                </ng-container>
                                                <ng-template #tarsSpecificOfferEmpty>
                                                    <p class="text-muted mb-0">No specific-offer recommendations are available.</p>
                                                </ng-template>
                                            </div>
                                        </details>
                                    </ng-container>

                                    <details class="tars-recommendation-scope" [open]="!hasTarsOfferSpecificContent(tarsAllOfferBenchmarks.offer_dependent_context)">
                                        <summary>ALL OFFERS</summary>
                                        <div class="tars-recommendations-panel">
                                            <p>These recommendations include same-brand campaigns across all offers.</p>
                                            <ng-container *ngTemplateOutlet="tarsRecommendationTable; context: { $implicit: tarsAllOfferBenchmarks.lead_form_candidates, title: 'Lead-form', metricKey: 'lsr', metricLabel: 'LSR' }"></ng-container>
                                            <ng-container *ngTemplateOutlet="tarsRecommendationTable; context: { $implicit: tarsAllOfferBenchmarks.copy_candidates, title: 'Copy', metricKey: 'ctr', metricLabel: 'CTR' }"></ng-container>
                                            <ng-container *ngTemplateOutlet="tarsRecommendationTable; context: { $implicit: tarsAllOfferBenchmarks.creative_candidates, title: 'Creative', metricKey: 'ctr', metricLabel: 'CTR' }"></ng-container>
                                        </div>
                                    </details>
                                </ng-container>
                                <ng-template #tarsRecommendationTable let-candidates let-title="title" let-metricKey="metricKey" let-metricLabel="metricLabel">
                                    <section class="tars-recommendation-table-section" *ngIf="candidates?.length">
                                        <h5>{{ title }}</h5>
                                        <div class="add-campaign-check-modal__metrics-table-shell">
                                            <table class="table table-sm mb-0 add-campaign-check-modal__metrics-table tars-recommendation-table">
                                                <thead>
                                                    <tr>
                                                        <th>Candidate</th>
                                                        <th class="text-end">Campaigns</th>
                                                        <th class="text-end">Ads</th>
                                                        <th class="text-end">Median {{ metricLabel }}</th>
                                                        <th class="text-end">Weighted {{ metricLabel }}</th>
                                                        <th class="text-end">CPL</th>
                                                        <th class="text-end">Leads</th>
                                                        <th class="text-end">Spend</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr *ngFor="let candidate of candidates">
                                                        <td>{{ candidate.label || candidate.group_key }}</td>
                                                        <td class="text-end">{{ candidate.campaign_count | number:'1.0-0' }}</td>
                                                        <td class="text-end">{{ candidate.ad_count | number:'1.0-0' }}</td>
                                                        <td class="text-end">{{ formatTarsMetricValue(getTarsCandidateMetric(candidate, 'campaign_median', metricKey), 'percent') }}</td>
                                                        <td class="text-end">{{ formatTarsMetricValue(getTarsCandidateMetric(candidate, 'weighted', metricKey), 'percent') }}</td>
                                                        <td class="text-end">{{ formatTarsMetricValue(getTarsCandidateCpl(candidate), 'currency') }}</td>
                                                        <td class="text-end">{{ candidate.total_leads | number:'1.0-0' }}</td>
                                                        <td class="text-end">{{ formatTarsMetricValue(candidate.total_spend, 'currency') }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </section>
                                </ng-template>
                                </ng-container>
                                <ng-template #tarsRecommendationsUnavailable>
                                    <p class="text-muted mb-0">No peer-benchmark recommendations are available.</p>
                                </ng-template>
                                    </div>
                                </details>
                                <details class="tars-response-section">
                                    <summary>METRICS</summary>
                                    <div class="tars-metrics-content" *ngIf="getTarsSectionData(tarsResponse, 'metrics') as tarsMetrics">
                                        <section class="tars-metrics-period" *ngFor="let period of tarsMetricPeriods">
                                            <div class="tars-metrics-period__heading">
                                                <h5>{{ period.label }}</h5>
                                                <button
                                                    *ngIf="period.key === 'current_7_days'"
                                                    type="button"
                                                    class="btn btn-sm btn-outline-secondary"
                                                    (click)="copyTarsMetricsToCheck(tarsMetrics.current_7_days)">
                                                    Copy to Check
                                                </button>
                                            </div>
                                            <div class="tars-metric-cards">
                                                <div
                                                    class="tars-metric-card"
                                                    *ngFor="let metric of tarsMetricCards"
                                                    [class.tars-metric-card--good]="getTarsMetricHealth(tarsMetrics, period.key, period.comparisonGroup, metric.key) === 'good'"
                                                    [class.tars-metric-card--bad]="getTarsMetricHealth(tarsMetrics, period.key, period.comparisonGroup, metric.key) === 'bad'">
                                                    <strong>{{ metric.label }}</strong>
                                                    <span class="tars-metric-card__value">{{ formatTarsMetricValue(getTarsMetricValue(tarsMetrics, period.key, metric.key), metric.format) }}</span>
                                                    <small *ngIf="getTarsMetricAverageLabel(tarsMetrics, period.key, 'brand', metric.key, metric.format, 'Brand Avg') as brandAverage">{{ brandAverage }}</small>
                                                    <small *ngIf="getTarsMetricAverageLabel(tarsMetrics, period.key, 'stage', metric.key, metric.format, getTarsStageAverageLabel(tarsResponse)) as stageAverage">{{ stageAverage }}</small>
                                                </div>
                                            </div>
                                        </section>
                                    </div>
                                </details>
                                <details class="tars-response-section">
                                    <summary>ADS</summary>
                                    <div class="tars-ads-content">
                                        <ng-container *ngIf="getTarsAdsRows(getTarsSectionData(tarsResponse, 'ads')) as tarsAdsRows; else tarsAdsEmpty">
                                            <div class="add-campaign-check-modal__metrics-table-shell tars-ads-table-shell" *ngIf="tarsAdsRows.length; else tarsAdsEmpty">
                                                <table class="table table-sm mb-0 add-campaign-check-modal__metrics-table tars-ads-table">
                                                    <thead>
                                                        <tr>
                                                            <th>Ad</th>
                                                            <th>Ad set</th>
                                                            <th class="text-end">7d spend</th>
                                                            <th class="text-end">Spend share</th>
                                                            <th class="text-end">7d leads</th>
                                                            <th class="text-end">7d CPL</th>
                                                            <th class="text-end">7d LSR</th>
                                                            <th class="text-end">30d CPL</th>
                                                            <th>Classification</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr *ngFor="let ad of tarsAdsRows">
                                                            <td>
                                                                <a *ngIf="getTarsAdField(ad, 'url', 'ad_url', 'link') as adUrl; else tarsAdName"
                                                                    [href]="adUrl" target="_blank" rel="noopener noreferrer">
                                                                    {{ getTarsAdField(ad, 'ad_name', 'ad', 'name', 'label') || '—' }}
                                                                </a>
                                                                <ng-template #tarsAdName>{{ getTarsAdField(ad, 'ad_name', 'ad', 'name', 'label') || '—' }}</ng-template>
                                                            </td>
                                                            <td>{{ getTarsAdField(ad, 'ad_set_name', 'adset_name', 'ad_set', 'adset') || '—' }}</td>
                                                            <td class="text-end">{{ formatTarsAdMetric(getTarsAdField(ad, 'current_7d.spend', 'spend_7d'), 'currency') }}</td>
                                                            <td class="text-end">{{ formatTarsAdMetric(getTarsAdField(ad, 'current_7d.spend_share', 'spend_share_7d', 'spend_share'), 'share') }}</td>
                                                            <td class="text-end">{{ formatTarsAdMetric(getTarsAdField(ad, 'current_7d.leads', 'leads_7d'), 'number') }}</td>
                                                            <td class="text-end">{{ formatTarsAdMetric(getTarsAdField(ad, 'current_7d.cpl', 'cpl_7d'), 'currency') }}</td>
                                                            <td class="text-end">{{ formatTarsAdMetric(getTarsAdField(ad, 'current_7d.lsr', 'lsr_7d'), 'percent') }}</td>
                                                            <td class="text-end">{{ formatTarsAdMetric(getTarsAdField(ad, 'current_30d.cpl', 'cpl_30d'), 'currency') }}</td>
                                                            <td>{{ formatTarsAdClassification(getTarsAdField(ad, 'classification')) }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </ng-container>
                                        <ng-template #tarsAdsEmpty>
                                            <p class="text-muted mb-0">No ad data is available.</p>
                                        </ng-template>
                                    </div>
                                </details>
                            </ng-container>
                        </ng-container>

                        <div class="text-muted" *ngIf="!tarsLoading && !tarsError && tarsResults.length === 0">
                            No TARS campaign review data available.
                        </div>
                        <button type="button"
                            class="btn btn-sm btn-outline-secondary mt-2"
                            *ngIf="!tarsLoading && tarsResults.length > 0 && hasTarsErrors"
                            (click)="loadTarsReview(true)">
                            Retry failed TARS request(s)
                        </button>
                    </div>
                    
                    <div class="row checkDetails add-campaign-check-modal__panel add-campaign-check-modal__panel--complete mt-3">
                        <div class="row mt-1">
                                <h5>{{ 'COMPLETE_CHECK' | translate }}:</h5>
                        </div>
                        <div fxLayout="row" fxLayoutGap="16px">
                            <div fxFlex>
                                <label for="leads">{{ metricCountLabel | translate }}</label>
                                <input type="text" class="form-control" formControlName="leads"
                                    [ngClass]="{ 'is-invalid': submitted && f.leads.errors }">
                            </div>

                            <div fxFlex>
                                <label for="cpl">{{ metricCostLabel | translate }}</label>
                                <input type="text" prefix="$" mask="separator.2" thousandSeparator="" class="form-control" formControlName="cpl"
                                    [ngClass]="{ 'is-invalid': submitted && f.cpl.errors }">
                            </div>

                            <div fxFlex>
                                <label for="ctr">{{ 'CTR' | translate }}</label>
                                <input type="text" suffix="%" mask="separator.4" thousandSeparator="" class="form-control" formControlName="ctr"
                                    [ngClass]="{ 'is-invalid': submitted && f.ctr.errors }">
                            </div>

                            <div fxFlex>
                                <label for="impression">{{ 'IMPR' | translate }}</label>
                                <input type="text" mask="separator.4" thousandSeparator="," class="form-control" formControlName="impression"
                                    [ngClass]="{ 'is-invalid': submitted && f.impression.errors }">
                            </div>

                            <div fxFlex>
                                <label for="cPMOrCPC">{{ (isGooglePlatform ? 'CPC' : 'CPM') | translate }}</label>
                                <input type="text" prefix="$" mask="separator.2" thousandSeparator="" class="form-control" formControlName="cPMOrCPC"
                                    [ngClass]="{ 'is-invalid': submitted && f.cPMOrCPC.errors }">
                            </div>

                            <div fxFlex>
                                <label for="lFSROrLPCR">{{ metricRateLabel | translate }}</label>
                                <input type="text" suffix="%" mask="separator.4" thousandSeparator="" class="form-control" formControlName="lFSROrLPCR"
                                    [ngClass]="{ 'is-invalid': submitted && f.lFSROrLPCR.errors }">
                            </div>
                        </div>
                        <div *ngIf="hasConversionActionBreakdown" class="mt-3 conversion-action-breakdown-panel">
                            <div class="conversion-action-breakdown-panel__text">
                                <span class="conversion-action-breakdown-panel__label">{{ 'CONVERSION_ACTIONS_INCLUDED' | translate }}:</span>
                                <span class="conversion-action-breakdown-panel__chips">
                                <span
                                    *ngFor="let action of conversionActionBreakdown"
                                    class="conversion-action-breakdown__item">
                                        <span style="font-weight: 600;">{{ action.label }}:</span>
                                    <span>{{ action.value | number:'1.0-0' }}</span>
                                </span>
                                </span>
                            </div>
                        </div>
                        <div class="mt-3" fxLayout="row" fxLayoutGap="16px">
                            <div fxFlex>
                                <div>
                                    <label for="insightText">{{ 'INSIGHTS' | translate }}</label>
                                    <textarea type="text" rows="5" class="form-control" formControlName="insightText"
                                        [ngClass]="{ 'is-invalid': submitted && f.insightText.errors }"
                                        [placeholder]="'INSIGHT_PLACEHOLDER' | translate"> </textarea>
                                    <div *ngIf="submitted && f.insightText.errors" class="invalid-feedback">
                                        <div *ngIf="f.insightText.errors.required">{{ 'INSIGHT_IS_REQUIRED' | translate }}</div>
                                    </div>
                                </div>
                                <div class="mt-3">
                                    <label for="changesText">{{ 'CHANGES' | translate }}</label>
                                    <textarea type="text" rows="5" class="form-control" formControlName="changesText"
                                        [ngClass]="{ 'is-invalid': submitted && f.changesText.errors }"
                                        [placeholder]="'CHANGES_PLACEHOLDER' | translate"> </textarea>
                                    <div *ngIf="submitted && f.changesText.errors" class="invalid-feedback">
                                        <div *ngIf="f.changesText.errors.required">{{ 'CHANGES_IS_REQUIRED' | translate }}</div>
                                    </div>
                                </div>
                            </div>

                            <div fxFlex>
                                <div fxLayout="column" fxFill>
                                    <div class="row">
                                        <label class="col-sm-12" for="addTaskDate">{{ 'SELECT_THE_NEXT_CHECK_DATE' | translate }}</label>
                                        <div class="col-sm-6">
                                            <input [ngClass]="{ 'is-invalid': submitted && f.addTaskDate.errors }" mwlFlatpickr [altInputClass]="'datetime'" [altInput]="true" [convertModelValue]="true" formControlName="addTaskDate"
                                            class="form-control" />
                                            <div *ngIf="submitted && f.addTaskDate.errors" class="invalid-feedback">
                                                <div *ngIf="f.addTaskDate.errors.required">{{ 'REQUIRED' | translate }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <label class="col-sm-12" for="nextTaskAssignedUserId">{{ 'ASSIGN_NEXT_CHECK_TO' | translate }}</label>
                                        <div class="col-sm-6">
                                            <ng-select
                                                [placeholder]="'DEFAULT_CAMPAIGN_DMS' | translate"
                                                [items]="allUsers"
                                                bindLabel="fullName"
                                                bindValue="id"
                                                formControlName="nextTaskAssignedUserId">
                                            </ng-select>
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <div fxLayout="row" class="add-campaign-check-modal__email-options">
                                            <div class="add-campaign-check-modal__checkbox-option">
                                                <div class="add-campaign-check-modal__checkbox-wrap">
                                                    <input type="checkbox" id="isQCCheck" formControlName="isQCCheck" class="form-check-input" />
                                                </div>
                                                <label class="add-campaign-check-modal__option-label" for="isQCCheck">{{ 'ADD_QC_CHECK' | translate }}</label>
                                            </div>
                                            <div class="add-campaign-check-modal__checkbox-option">
                                                <div class="add-campaign-check-modal__checkbox-wrap">
                                                    <input type="checkbox" id="isAIEmail" formControlName="isAIEmail" class="form-check-input" />
                                                </div>
                                                <label class="add-campaign-check-modal__option-label" for="isAIEmail">{{ 'AI_EMAIL' | translate }}</label>
                                                
                                                <div class="add-campaign-check-modal__model-select">
                                                    <ng-select
                                                        id="aiRewriteModel"
                                                        [items]="aiRewriteModels"
                                                        formControlName="aiRewriteModel"
                                                        [clearable]="false">
                                                    </ng-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <label for="assignedUserId">{{ 'INCLUDE_ATTACHMENT_ON_NOTE' | translate }}</label>
                                        <span>
                                            <ngx-dropzone style="height: 80px;" [multiple]="false" (change)="onSelect($event)">
                                                <ngx-dropzone-label>{{ 'DROP_OR_CLICK_TO_UPLOAD' | translate }}</ngx-dropzone-label>
                                            </ngx-dropzone>
                                            <div class="row mt-3" style="margin: 10px;" *ngFor="let file of files">
                                                <div class="col-sm-9">{{ file.name }}</div>
                                                <div class="col-sm-3">
                                                    <a role="button" (click)="onRemove(file)">
                                                        <i class="fas fa-trash-can"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer modal-bar add-campaign-check-modal__footer" cdkDragHandle>
            <button type="button" class="red-outline-button add-campaign-check-modal__button add-campaign-check-modal__button--cancel" (click)="activeModal.close('Close click')">{{ 'CANCEL' | translate }}</button>
            <button type="submit" class="blue-button add-campaign-check-modal__button">{{ 'COMPLETE_CHECK' | translate }}</button>
        </div>
    </form>
</div>
